import { Card, Space } from 'antd';
import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useLocation } from 'react-router-dom';
import style from './LeftBar.module.css';
import MetricTree from './MetricTree.jsx';
import ResRadar from './ResRadar.jsx';
import { $showPresets } from '../../models/dataPresetsModel/index.js';
import DataPresets from '../DataPresets/DataPresets.jsx';

export default function LeftBar() {
  const [expanded, setExpanded] = useState(['1']);
  const { pathname } = useLocation();

  const onExpand = (value) => {
    setExpanded(value);
  };

  if (pathname === '/public') {
    return (
      <Space direction="vertical" className={style.left_bar} id="left_demo_bar">
        <div style={{ position: 'relative', height: '100%' }}>
          <MetricTree expanded={false} />
        </div>
      </Space>
    );
  }

  return (
    <Space direction="vertical" className={style.left_bar} id="left_bar">
      <ResRadar onExpand={onExpand} expanded={expanded} />
      <div style={{ position: 'relative', height: '100%' }}>
        <DataPresets />
        <MetricTree expanded={expanded} />
      </div>
    </Space>
  );
}
